import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 要助人api
 */
class orderApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢訂單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getOrder(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_ORDER}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 新增訂單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     */
    addOrder(callback = {}, params = {}) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_POST_ORDER}`,
          data: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 更新訂單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updateOrder(callback = {}, params = {}) {
      const options = {
          method: this.request.method.put,
          url: `${apiUrl.API_PUT_ORDER}/${params.id}`,
          data: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 匯出詳細訂單EXCEL
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    exportOrderDetail(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_ORDER_DETAIL}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

}

export default orderApi;



// WEBPACK FOOTER //
// ./src/models/API/orderApi.js